/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconRepositories = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { d: "M12.851 1.853a1.204 1.204 0 0 0-1.702 0l-1.95 1.95 2.363 2.364a1.62 1.62 0 0 1 2.104 1.547c0 .168-.025.331-.073.484l2.344 2.344a1.62 1.62 0 1 1-.97.97l-2.134-2.134V15a1.62 1.62 0 1 1-1.389-.088V9.22a1.62 1.62 0 0 1-.895-2.125l-2.32-2.32-6.376 6.375c-.47.47-.47 1.232 0 1.702l9.296 9.296c.47.47 1.232.47 1.702 0l9.296-9.296c.47-.47.47-1.232 0-1.702l-9.296-9.296Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconRepositories.displayName = 'IconRepositories';
export default IconRepositories;
